import { styled, TextField, TextFieldProps } from '@mui/material';

export const StyledInput = styled(TextField)<TextFieldProps>`
  width: 100%;
  font-size: 0.875rem;

  .MuiInputBase-root {
    padding: 3px 11px !important;
    min-height: 44px;
    align-items: flex-start;
  }

  .MuiInputBase-input {
    padding-top: 8px;
  }

  fieldset {
    border-radius: 22px;
  }
`;
